<template>
	<div class="container">
		<CCalendar :value.sync="dateValue" :scheduleData="scheduleData" :styles="['circle-calendar']" />
		<div class="schedule-wrap">
			<CFullEmpty
				v-if="isEmptySchedules"
				:emptySvg="NON_SCHEDULE"
				:emptyText="$t('enterprise.No-events-on-the-selected-date')"
				class="schedule-empty"
			/>
			<div v-else class="schedule-list">
				<CScheduleItem
					v-for="(item, index) in generateLimitedDisplayData(dateValue)"
					:key="index"
					:item="item"
				></CScheduleItem>
			</div>
		</div>
		<div v-if="appointmentName" class="survey-btn" @click="JumpToAppoint">
			<span>{{ appointmentName }}</span>
		</div>
	</div>
</template>

<script>
import CCalendar from '@/view/enterprise/components/calendar/c-calendar.vue';
import CScheduleItem from '@/view/enterprise/components/calendar/c-schedule-item.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import { mapGetters } from 'vuex';
import useScheduleCache from './mixins/useScheduleCache';
import { calculateDateRange, filterDataByTimeRange, getMonthRange } from '@/store/modules/calendar';
import NON_SCHEDULE from '@/assets/images/irstore/non_schedule.svg';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { computed } from 'vue';

export default {
	mixins: [useScheduleCache],
	components: {
		CCalendar,
		CScheduleItem,
		CFullEmpty
	},
	data() {
		return {
			NON_SCHEDULE,
			dateValue: new Date(),
			scheduleData: []
		};
	},
	computed: {
		...mapGetters({
			'getIrBaseInfo': 'getIrBaseInfo',
			'getIrGlobalModules': 'getIrGlobalModules'
		}),
		isEmptySchedules() {
			const schedules = this.generateLimitedDisplayData(this.dateValue);
			return !schedules.length;
		},
		appointmentName() {
			let target = this.getIrGlobalModules.find(item => item.moduleId == 'appointment');
			return target?.name;
		}
	},
	watch: {
		dateValue(val) {
			this.UPDATE_SCHEDULE_RENDER(val);
		}
	},
	mounted() {
		this.queryScheduleList(this.dateValue);

		const onScheduleUpdate = () => {
			this.queryScheduleList(this.dateValue);
		};
		this.REGISTER_ON_RENDER_UPDATE(onScheduleUpdate);
	},
	methods: {
		async queryScheduleList(date) {
			const [rangeStart, rangeEnd] = getMonthRange(date);
			const _cache = []; // 覆盖缓存
			[
				this.$moment(date).format('YYYYMM'),
				this.$moment(rangeStart).format('YYYYMM'),
				this.$moment(rangeEnd).format('YYYYMM')
			].forEach(d => {
				_cache.push(d);
			});
			// 记录已经拿到数据的日期信息
			this.RESET_CACHED_SCHEDULE_MONTH_KEYS([...new Set(_cache)]);

			await this.loadScheduleList({
				startTime: rangeStart,
				endTime: rangeEnd
			});
			this.scheduleData = this.getScheduleList;
		},

		// 生成日程数据
		extractDataForDateRange(date) {
			const originSchedule = this.scheduleData;
			const range = calculateDateRange(date, 'day');
			const rangeResult = filterDataByTimeRange(range, originSchedule);
			if (!rangeResult) return [];
			return rangeResult;
		},
		generateLimitedDisplayData(date) {
			if (!this.scheduleData.length) return [];
			return this.extractDataForDateRange(date);
		}
	},
	setup() {
		const { customs_calendar } = useModuleData();
		const loadScheduleList = async params => {
			await customs_calendar.refresh(params);
		};
		const getScheduleList = computed(() => customs_calendar.data?.data || []);

		const { goToModule } = useNavigation();
		const JumpToAppoint = () => {
			// 防止缓存命中：fullPath
			goToModule('appointment', { r: new Date().getTime() });
		};

		return {
			loadScheduleList,
			getScheduleList,
			JumpToAppoint
		};
	}
};
</script>

<style lang="less" scoped>
.container {
	height: 100%;
	display: flex;
	flex-direction: column;

	.schedule-wrap {
		flex: 1;
		height: 0;
		overflow-y: auto;

		/deep/ .schedule-empty {
			img {
				width: 2rem;
				height: 1.72rem;
			}
		}
		// TODO 日历滚动列表下边距需要调整
		.schedule-list {
			padding: 0.14rem;
		}
	}
	.survey-btn {
		display: flex;
		width: 100%;
		padding: 0.12rem 0.14rem;
		padding-bottom: calc(0.12rem + constant(safe-area-inset-bottom));
		padding-bottom: calc(0.12rem + env(safe-area-inset-bottom));
		box-shadow: 0px -3px 7px rgba(0, 0, 0, 0.02);
		background: #fff;
		span {
			padding: 0.1rem;
			flex: 1;
			font-size: 0.16rem;
			text-align: center;
			color: #fff;
			background: var(--ir-theme-color);
		}
	}
}
</style>
